<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item style="margin-bottom: 0px" label="所属企业">
        <tenantSelector
          style="width: 200px; height: 24px"
          v-model="filters.tenant"
          auto-complete="off"
        />
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="预约类型">
        <enumSelector2
          ref="enumSelector1"
          :options="$config.appointType"
          v-model="filters.appType"
        />
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="预约状态">
        <enumSelector2
          ref="enumSelector2"
          :options="$config.appointStatus"
          v-model="filters.appStatus"
        />
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="关键字">
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="关键词"
          clearable
          style="width: 200px"
          @keyup.native.enter="queryAll"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px">
        <el-button size="small" type="primary" @click="queryAll"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table border :data="datas" style="width: 100%" size="small">
      <el-table-column
        prop="FromMember.Mobile"
        label="预约人手机号"
        width="150"
      ></el-table-column>
      <el-table-column prop="FromMember" label="预约人"  min-width="160">
        <template slot-scope="scope">
          <viewer>
            
            <img
              v-if="scope.row.FromMember.HeadImage"
              :src="
                scope.row.FromMember.HeadImage.indexOf('http') == 0
                  ? scope.row.FromMember.HeadImage
                  : baseUrl + scope.row.FromMember.HeadImage
              "
              :key="scope.row.FromMember.HeadImage"
              width="30"
            />
            <span>{{ scope.row.FromMember.RealName }}</span>
            <span v-if="scope.row.FromMember.Actor.Code!='HT'">@{{ scope.row.FromMember.Actor.Name }}</span>
          </viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="ToMember.Mobile"
        label="接收预约人手机号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ToMember"
        label="接收预约人"
        min-width="160"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
          <viewer>
           
            <img
              v-if="scope.row.ToMember.HeadImage"
              :src="
                scope.row.ToMember.HeadImage.indexOf('http') == 0
                  ? scope.row.ToMember.HeadImage
                  : baseUrl + scope.row.ToMember.HeadImage
              "
              :key="scope.row.ToMember.HeadImage"
              width="30"
            />
            <span>{{ scope.row.ToMember.RealName }}</span>
            <span v-if="scope.row.ToMember.Actor.Code!='HT'">@{{ scope.row.ToMember.Actor.Name }}</span>
          </viewer>
        </template>
    </el-table-column>
      <el-table-column prop="Desc" label="预约内容" min-width="200">
      </el-table-column>
      <el-table-column prop="Status" label="预约状态" width="150">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.Status == 0">意向</el-tag>
          <el-tag type="success" v-if="scope.row.Status == 10">达成</el-tag>
          <el-tag type="info" v-if="scope.row.Status == 20">未达成</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="InsertTime" sortable label="创建时间" width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleRemove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>
    <script>
import { getPageList, save } from "@/api/business/appoint.js";
import tenantSelector from "@/components/tenantSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
export default {
  components: { tenantSelector, enumSelector2 },
  data() {
    return {
      datas: [],
      filters: {
        tenant: "",
        appStatus: "",
        appType: "",
        search: "",
      },
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      totalCount: 0,
    };
  },
  methods: {
    queryAll() {
      let param = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        tenant: this.filters.tenant ? this.filters.tenant.Key : "",
        appType: this.filters.appType,
        appStatus: this.filters.appStatus,
      };
      getPageList(param).then((res) => {
        this.datas = res.Items;
        this.totalCount = res.Total | res.Items.length;
      });
    },
    doSave(row) {
      save(row).then((res) => {
        if (res) {
          this.msg.successMsg("保存成功！");
        }
      });
    },
    handleRemove(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          key: row.Key,
        };
        del(param)
          .then((res) => {
            if (res) {
              this.queryAll();
            }
          })
          .catch((ex) => {});
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryAll();
    },
  },
  mounted() {
    this.tabs = this.$config.tenantStatus;
    this.queryAll();
  },
};
</script>
    <style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}
/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>